import "./map.css"

import { ReactNode } from "react";
import { MapContainer, MapContainerProps, TileLayer } from "react-leaflet";

function OpenStreetMap<Props extends MapContainerProps = MapContainerProps>({
    children,
    scrollWheelZoom = true,
    zoomControl = false,
    ...otherProps
}: Props): ReactNode {
    return (
        <MapContainer
            className={"map openstreet-map"}
            scrollWheelZoom={scrollWheelZoom}
            zoomControl={zoomControl}
            {...otherProps}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {children}
        </MapContainer>
    )
}

export default OpenStreetMap;